import axios from "axios";
import { MAIN_API, SSENSE_URL } from "./stepoutAPI";
import { decryptResponse } from "../utils/decryptData";
import apiClient from "../utils/axiosClient";

// export const getAllMatchesByAnalystId = async ({
//   page = 0,
//   analyst_id,
//   token,
//   searchMatchId,
//   searchTournament,
//   searchTeam,
//   searchByAnalyzed,
//   startDate,
//   endDate,
// }) => {
//   try {
//     let url = `${MAIN_API}get_matches_by_analyst_id/?offset=${page}&limit=20`;

//     const response = await axios({
//       method: "POST",
//       url,
//       data: {
//         analyst_id: analyst_id,
//         match_id: searchMatchId,
//         team_name: searchTeam,
//         tournament_name: searchTournament,
//         match_status: searchByAnalyzed,
//         // match_status: [1, 2, 4, 5, 3],
//         start_date: startDate,
//         end_date: endDate,
//       },
//       headers: {
//         Authorization: "ANALYST " + token,
//         "Content-Type": "application/json",
//       },
//     });
//     // const response_data = decryptResponse(response?.data?.response_data, true);
//     const response_data = response?.data?.response_data;
//     return response_data;
//   } catch (error) {
//     throw error;
//   }
// };

export const getAllMatchesByAnalystId = async ({
  page = 0,
  analyst_id,
  token,
  searchMatchId,
  searchTournament,
  searchTeam,
  searchByAnalyzed,
  startDate,
  endDate,
}) => {
  try {
    const response = await apiClient.post(
      "get_matches_by_analyst_id/",
      {
        analyst_id,
        match_id: searchMatchId,
        team_name: searchTeam,
        tournament_name: searchTournament,
        match_status: searchByAnalyzed,
        start_date: startDate,
        end_date: endDate,
      },
      {
        params: {
          offset: page,
          limit: 20,
        },
        headers: {
          Authorization: `ANALYST ${token}`,
        },
      }
    );

    return response?.data?.response_data;
  } catch (error) {
    throw error;
  }
};
export const getReviewerFeedbackStrings = async ({
  matchId,
  token,
  reviewerId,
}) => {
  try {
    const { data } = await axios({
      method: "GET",
      url: `${SSENSE_URL}get_reviewer_feedback/?match_id=${matchId}&reviewer_id=${reviewerId}`,
      headers: {
        Authorization: "ANALYST " + token,
        "Content-Type": "application/json",
      },
    });
    return data?.response_data;
  } catch (error) {
    throw error;
  }
};

export const saveReviewerFeedback = async ({ token, body }) => {
  try {
    const { data } = await axios.post(
      `${SSENSE_URL}save_reviewer_feedback/`,
      body,
      {
        headers: {
          Authorization: `ANALYST ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getMatchById = async ({ match_id, token }) => {
  try {
    const { data } = await axios({
      method: "GET",
      url: `${MAIN_API}matchById/${match_id}?hashed_required=true`,
      headers: {
        Authorization: "ANALYST " + token,
        "Content-Type": "application/json",
      },
    });
    return decryptResponse(data?.response_data, true);
  } catch (error) {
    throw error;
  }
};

export const updateEventLog = async ({
  matchId,
  analystId,
  eventLog,
  token,
}) => {
  try {
    const res = await axios.post(
      `${MAIN_API}update_analysis_event_log/`,
      {
        match_id: parseInt(matchId),
        analyst_id: parseInt(analystId),
        event: eventLog,
      },
      {
        headers: {
          Authorization: `ANALYST ${token}`,
        },
      }
    );
    return res.response_data;
  } catch (err) {
    console.error(err);
  }
};

export const updateMatchStatus = async ({
  match_id,
  match_status,
  token,
  reviewer_id,
}) => {
  const response = await axios.post(
    `${MAIN_API}update_match_status/`,
    {
      match_id,
      match_status,
      reviewer_id,
    },
    {
      headers: {
        Authorization: "ANALYST " + token,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getMatchLiveData = async ({ matchId }) => {
  try {
    const res = await axios.post(`${SSENSE_URL}get_live_tag_data/`, {
      match_id: parseInt(matchId),
    });
    return res?.data?.response_data;
  } catch (err) {
    console.error("Error fetching live data:", err);
    return null;
  }
};

export const PushMatchLiveData = async ({
  matchId,
  teamAStats,
  teamBStats,
}) => {
  try {
    const payload = {
      match_id: parseInt(matchId),
      data: {
        team_a_details: teamAStats,
        team_b_details: teamBStats,
      },
    };

    const res = await axios.post(`${SSENSE_URL}push_live_tag_data/`, payload);
    return res?.data;
  } catch (err) {
    console.error("Error pushing live data:", err);
    return null;
  }
};

export const updateLiveTaggingStatus = async ({
  match_id,
  live_tagging_status,
  token,
}) => {
  const response = await axios.post(
    `${MAIN_API}update_live_tagging_status/`,
    {
      match_id,
      live_tagging_status,
    },
    {
      headers: {
        Authorization: "ANALYST " + token,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const fetchMatchStringById = async (match_id, analyst_id, token) => {
  try {
    const data = {
      match_id,
      analyst_id,
    };

    const response = await axios.post(
      `${SSENSE_URL}get_match_video_string/v2/`,
      data,
      {
        headers: {
          Authorization: `ANALYST ${token}`,
        },
      }
    );

    return response?.data;
  } catch (error) {
    console.error("Error fetching match string:", error);
    return null;
  }
};

export const runTechQC = async (event_strings, token, match_id) => {
  try {
    const data = {
      event_strings,
      match_id,
    };

    const response = await axios.post(`${SSENSE_URL}perform_tech_qc/`, data, {
      headers: {
        Authorization: `ANALYST ${token}`,
      },
    });

    return response?.data;
  } catch (error) {
    console.error("Error fetching match string:", error);
    return null;
  }
};

export const pushCompletedTechQCString = async (
  match_id,
  analyst_id,
  token,
  match_string,
  force_update //only enabled in techQC
) => {
  const data = {
    match_id,
    analyst_id,
    match_string,
    force_update,
  };

  try {
    const response = await axios.post(
      `${SSENSE_URL}push_match_video_string/v2/`,
      data,
      {
        headers: {
          Authorization: "ANALYST " + token,
        },
      }
    );

    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: "Unexpected status code" };
    }
  } catch (error) {
    console.error("API Error:", error);
    return { success: false, error: error.message };
  }
};
